module.exports = __webpack_public_path__ + "static/media/f_hairstyle_frizzy_long_front_shadow.f7dbae37.png";